export default "__VITE_ASSET__XKAO9YRf__"